export default {
    cz: {
        joinUs: 'Přidejte se k nám',
        info1: {
            dek_cz: '170 000 stavebníků',
            argos_cz: '16 000 zákazníků',
        },
        info2: {
            dek_cz: ' využívá unikátní výhody, které osobní účet DEK přináší',
            argos_cz: ' využívá unikátní výhody, které osobní účet ARGOS přináší',
        },
        benefits: [
            'všechny doklady na jednom místě',
            'kontrola stavu objednávky již od zadání',
            'přehled o aktuálně probíhajících akcích',
            'využití věrnostního programu',
        ],
        createAccount: 'Vytvořit účet',
        link: '/registrace',
    },
    sk: {
        joinUs: 'Pridajte sa k nám',
        info1: {
            dek_sk: '15 000 stavebníkov',
        },
        info2: {
            dek_sk: ' využíva unikátne výhody, ktoré osobný účet DEK prináša',
        },
        benefits: [
            'všetky doklady na jednom mieste',
            'kontrola stavu objednávky už od zadania',
            'prehľad o aktuálne prebiehajúcich akciách',
            'využitie vernostného programu',
        ],
        createAccount: 'Vytvoriť účet',
        link: '/registracia',
    },
}
